import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppLayout from "@/components/layout/AppLayout";
import { Card } from "@/components/ui/card";
import { api } from "@/lib/api";
import { getIcon } from "@/config/icons";

export default function MasterHome() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/master/defs")
      .then((r) => setCategories(r.data.categories || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AppLayout title="Master Data" subtitle="Single source of truth for the entire platform · Manage all reference data">
      {loading && <div className="text-slate-400 text-sm" data-testid="master-home-loading">Loading masters…</div>}
      <div className="space-y-8" data-testid="master-home">
        {categories.filter((c) => c.masters.length).map((cat) => {
          const CatIcon = getIcon(cat.icon);
          return (
            <section key={cat.key} data-testid={`master-category-${cat.key}`}>
              <div className="flex items-center gap-2 mb-3">
                <CatIcon className="h-4 w-4 text-sky-700" />
                <h2 className="text-base font-semibold text-slate-800" style={{ fontFamily: "Chivo" }}>{cat.label}</h2>
                <span className="text-xs text-slate-400">({cat.masters.length})</span>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
                {cat.masters.map((m) => {
                  const Icon = getIcon(m.icon);
                  return (
                    <Card
                      key={m.key}
                      data-testid={`master-card-${m.key}`}
                      onClick={() => navigate(`/master/${m.key}`)}
                      className="p-4 cursor-pointer hover:border-sky-400 hover:shadow-md transition group"
                    >
                      <div className="flex items-start justify-between">
                        <div className="h-9 w-9 rounded-md bg-sky-50 border border-sky-100 flex items-center justify-center group-hover:bg-sky-100">
                          <Icon className="h-4 w-4 text-sky-700" />
                        </div>
                        <div className="text-right">
                          <div className="text-lg font-bold text-slate-800 leading-none" style={{ fontFamily: "Chivo" }}>{m.active}</div>
                          <div className="text-[10px] uppercase tracking-wider text-slate-400">Active</div>
                        </div>
                      </div>
                      <div className="mt-3 font-medium text-slate-800 text-sm">{m.label}</div>
                      <div className="text-xs text-slate-400 mt-0.5">{m.total} record{m.total === 1 ? "" : "s"}</div>
                    </Card>
                  );
                })}
              </div>
            </section>
          );
        })}
      </div>
    </AppLayout>
  );
}
